/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_ParallelInputs */

const en_mk_team_control_parallel = /** @type {(inputs: Mk_Team_Control_ParallelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set team size and usage thresholds`)
};

const id_mk_team_control_parallel = /** @type {(inputs: Mk_Team_Control_ParallelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur jumlah agent dan pemakaian`)
};

/**
* | output |
* | --- |
* | "Set team size and usage thresholds" |
*
* @param {Mk_Team_Control_ParallelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_parallel = /** @type {((inputs?: Mk_Team_Control_ParallelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_ParallelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_parallel(inputs)
	return en_mk_team_control_parallel(inputs)
});